import CopilotStartHeader from './components/CopilotStartHeader/CopilotStartHeader'
import CopilotHeaderBase from './components/CopilotHeaderBase/CopilotHeaderBase'
import {getGreeting} from './helpers/get-greeting'
import {useDashboardUniverse2025ToggleFeaturePreview} from './hooks/useDashboardUniverse2025ToggleFeaturePreview'

export interface CopilotChatInputHeaderProps {
  displayName: string
  showZeroUserHeader?: boolean
  alternateZeroUserHeaderEnabled?: boolean
  feedbackDialogEnabled?: boolean
  feedbackSubject?: string
  /**
   * When true, hides the Copilot animation logo from the header.
   * Use this when the logo should not be displayed, such as in minimal or alternative header views.
   */
  hideLogo?: boolean
}

export function CopilotChatInputHeader({
  displayName,
  showZeroUserHeader = false,
  alternateZeroUserHeaderEnabled = false,
  feedbackDialogEnabled = false,
  feedbackSubject,
  hideLogo = false,
}: CopilotChatInputHeaderProps) {
  const onToggleFeaturePreview = useDashboardUniverse2025ToggleFeaturePreview()

  if (showZeroUserHeader && alternateZeroUserHeaderEnabled) {
    return <CopilotStartHeader />
  } else if (showZeroUserHeader) {
    const message = `Welcome to GitHub, ${displayName}!`

    return (
      <CopilotHeaderBase
        message={message}
        feedbackDialogEnabled={feedbackDialogEnabled}
        feedbackSubject={feedbackSubject}
        hideLogo={hideLogo}
        onToggleFeaturePreview={onToggleFeaturePreview}
      />
    )
  }

  const message = getGreeting(displayName)

  return (
    <CopilotHeaderBase
      message={message}
      feedbackDialogEnabled={feedbackDialogEnabled}
      feedbackSubject={feedbackSubject}
      hideLogo={hideLogo}
      onToggleFeaturePreview={onToggleFeaturePreview}
    />
  )
}
